import { BrandingOrganisation } from '../branding/Branding';
import { env, EnvType } from './env.ts';
import packageJson from '../../package.json';

export interface AppConfig {
  environment: 'local' | 'development' | 'uat' | 'production';
  version: string;
  brandingOrganisation: BrandingOrganisation;
  apiUrl: string;
  graphQlUrl: string;
  pageTitlePrefix: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0CallbackUrl: string;
  auth0Audience: string;
  auth0Organisation?: string;
}

const throwIfUndefined = (envVar: keyof EnvType): string => {
  if (env[envVar] === undefined) {
    throw new Error(`${String(envVar)} is not defined, cannot load application config`);
  }

  return env[envVar]!;
};

let config: AppConfig;

export const getConfig = (): AppConfig => {
  if (config) return config;
  let deploymentTarget = throwIfUndefined('VITE_ENV');
  if (!['local', 'development', 'uat', 'production'].includes(deploymentTarget)) {
    deploymentTarget = 'production';
  }

  config = {
    environment: deploymentTarget as 'local' | 'development' | 'uat' | 'production',
    version: packageJson.version.trim(),
    brandingOrganisation: throwIfUndefined('VITE_BRANDING_ORGANISATION') as BrandingOrganisation,
    apiUrl: throwIfUndefined('VITE_BACKEND_HOST'),
    graphQlUrl: throwIfUndefined('VITE_GRAPHQL_URL'),
    pageTitlePrefix: env['VITE_PAGE_TITLE_PREFIX'],
    auth0Domain: throwIfUndefined('VITE_AUTH0_DOMAIN'),
    auth0ClientId: throwIfUndefined('VITE_AUTH0_CLIENT_ID'),
    auth0CallbackUrl: throwIfUndefined('VITE_AUTH0_CALLBACK_URL'),
    auth0Audience: throwIfUndefined('VITE_AUTH0_AUDIENCE'),
    auth0Organisation: env['VITE_AUTH0_ORGANISATION'],
  };

  return config;
};
